module.exports = "/_next/static/images/EngineeringExpertise-a48371a83f646ef20ba909f99a94eb10.webp";